import Vue from 'vue';
import _ from 'lodash';
import { v4 as uuid } from 'uuid';

const moves = require('@/helpers/moves.json')

const move = {
  namespaced: true,
  state: {
    movesCategories: [
      {
        name: 'adventure',
      },
    ],
    moves: [],

  },

  getters: {
    allMoves(state) {
      return state.moves;
    },
    moveByID: state => moveID => {
      return _.find(state.moves, {id: moveID});
    },
  },

  mutations: {
    setMoves(state, moves) {
      state.moves = moves;
    }
  },

  actions: {
    initialize({ commit }) {
      commit('setMoves', moves)
    },

    rollMove({commit, rootState}, payload) {
      let statBonus
      if ( // is a 'vital'
        (payload.stat === 'health') ||
        (payload.stat === 'spirit') ||
        (payload.stat === 'supply')
      ) {
        statBonus = rootState.character.vitals[payload.stat].current
        } else if (payload.stat === 'progress') {
          console.log('that was a progress move')
        } else { // is a 'stat'
        statBonus = rootState.character.stats[payload.stat]
      }
      const statRolled = payload.stat

      const result = Vue.rolling.challengeRoll(statBonus)

      const entry = {
        uuid: uuid(),
        entryType: 'move',
        statBonus: statBonus,
        statRolled: statRolled,
        result: result,
        createdAt: new Date().getTime(),
        moveTitle: payload.moveTitle,
        moveResult: payload[result.type],
      };
      commit('log/addRollEntry', entry, { root: true })
    },

  },
}

export default move
